/** Typical clear-day FV hourly production profile (relative to peak = 1.0). Index = hour 0-23. */
export const HOURLY_PROFILE = [
	0, 0, 0, 0, 0, 0.01, 0.04, 0.12, 0.28, 0.52, 0.75, 0.92, 1.0, 0.98, 0.88, 0.68, 0.4, 0.18, 0.05,
	0.01, 0, 0, 0, 0,
] as const;

export const SOLAR_HOURS = { sunrise: 6, sunset: 20, peak: 13 } as const;

export const DISPLAY_HOURS = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20] as const;
